import { createSelector } from 'reselect';

export const collectionSelector = createSelector(
  (state) => state.collection,
  (collection) => collection
);

export const collectionTitleSelector = createSelector(
  [collectionSelector, (state) => state.d_channels],
  (collection, navigation) => {
    const currentChannel = navigation.find((navItem) => navItem.id === collection.channelId);
    if (currentChannel && currentChannel.name !== 'Home') {
      return currentChannel.name;
    } else {
      return '';
    }
  }
);

export const collectionTotalNumberOfItemsSelector = createSelector(
  collectionSelector,
  (collection) => collection.totalCount
);

export const collectionCurrentPageSelector = createSelector(collectionSelector, (collection) => collection.pageNum);

export const collectionVideosSelector = createSelector(collectionSelector, (collection) =>
  collection.videos ? collection.videos : null
);

export const isCollectionLoadingSelector = createSelector(collectionSelector, (collection) => collection.isLoading);
